import { Component, Input } from '@angular/core';
import { AbstractControl, AbstractControlDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error-component',
  templateUrl: './field-input-error.component.html',
  styleUrls: ['./field-input-error.component.css'],
})
export class FieldInputErrorComponent {
  errorMsgList: any = [];

  @Input() controlName: AbstractControl | AbstractControlDirective;

  constructor(private translate: TranslateService) {}

  errorMessage = {
    required: () => this.translate.instant('validation.required'),
    maxlength: params =>
      this.translate.instant('validation.maxlength', { max: params.requiredLength }),
    minlength: params =>
      this.translate.instant('validation.minlength', { min: params.requiredLength }),
    pattern: () => this.translate.instant('validation.pattern'),
    min: params => this.translate.instant('validation.min', { min: params.min }),
    max: params => this.translate.instant('validation.max', { max: params.max }),
    whitespace: () => this.translate.instant('validation.whitespace'),
    email: () => this.translate.instant('validation.email'),
  };

  listErrors() {
    if (!this.controlName) {
      return [];
    }
    if (this.controlName.errors) {
      this.errorMsgList = [];
      Object.keys(this.controlName.errors).forEach(error => {
        this.errorMsgList.push(this.errorMessage[error](this.controlName.errors[error]));
      });
      return this.errorMsgList;
    } else {
      return [];
    }
  }
}
